const setupFilterByType = () => {
  const filters = document.querySelectorAll(".filters input");
  const articles = document.querySelectorAll("[data-filter]");

  function updateFilter() {
    const checkedFilters = Array.from(filters)
      .filter((input) => input.checked)
      .map((input) => input.id);

    articles.forEach((article) => {
      if (checkedFilters.includes(article.dataset.filter)) {
        article.style.display = "";
      } else {
        const isSupernova = article.hasAttribute("data-tag");
        const tagIsChecked = document.querySelector("#supernova").checked;

        if (isSupernova && tagIsChecked) {
          article.style.display = "";
        } else {
          article.style.display = "none";
        }
      }
    });

    document.querySelectorAll(".product-flex").forEach((parent) => {
      const children = Array.from(parent.children);

      const allHidden =
        children.length > 0 &&
        children.every((child) => getComputedStyle(child).display === "none");

      parent.parentElement.classList.toggle("empty", allHidden);
    });
  }

  filters.forEach((input) => input.addEventListener("change", updateFilter));

  updateFilter();
};

const setupFilterByTag = () => {
  const tags = document.querySelectorAll(".tags input");
  const products = document.querySelectorAll("[data-tag='supernova']");

  if (products.length < 1) return;

  const hasSupernova = Array.from(products).some((element) =>
    element.dataset.tag.toLowerCase().includes("supernova"),
  );

  if (!hasSupernova) {
    document.querySelector(".tags").remove();
    return;
  }

  function updateTagFilter() {
    const checkedFilters = Array.from(tags)
      .filter((input) => input.checked)
      .map((input) => input.id);

    products.forEach((product) => {
      const tags = product.dataset.tag;

      const matches = checkedFilters.some((filter) => {
        return tags.indexOf(filter) !== -1;
      });

      product.style.display = matches ? "" : "none";
    });

    document.querySelectorAll(".product-flex").forEach((parent) => {
      const children = Array.from(parent.children);

      const allHidden =
        children.length > 0 &&
        children.every((child) => getComputedStyle(child).display === "none");

      parent.parentElement.classList.toggle("empty", allHidden);
    });
  }

  tags.forEach((input) => {
    input.addEventListener("change", updateTagFilter);
  });

  updateTagFilter();
};

document.addEventListener("DOMContentLoaded", function () {
  setupFilterByType();
  setupFilterByTag();
});
